<dialog #dialog class="session-expiry-warning" id="main-session-expiry-warning" (cancel)="preventClose($event)">
  <div class="session-expiry-warning__header">
    <h2 class="session-expiry-warning__title">Session Expiring Soon</h2>
  </div>
  <div class="session-expiry-warning__content">
    <p class="session-expiry-warning__message">
      You have been inactive. Your session will end due to inactivity unless you extend it.
    </p>
    <div class="session-expiry-warning__countdown-box">
      <span id="session-expiry-countdown">{{ remainingTimeDisplay }}</span>
    </div>
    <p class="session-expiry-warning__hint">
      If you do not respond, you will be logged out when the timer reaches zero. Your current screen will stay as-is if you choose Extend Session.
    </p>
  </div>
  <div class="session-expiry-warning__actions">
    <button id="btn-extend-session"
      type="button"
      class="gd2-btn gd2-btn-primary session-expiry-warning__extend-btn"
      autofocus
      [disabled]="isExtending"
      (click)="extendSession()"
    title="Extend Session">
      <span>Extend Session</span>
      <span class="session-expiry-warning__extend-icon" aria-hidden="true">&#9650;</span>
    </button>
  </div>
</dialog>
